module.exports = __webpack_public_path__ + "static/media/40-beach-group.6aa56609.jpg";